import { ReactNode } from 'react'

import { CommonNoticeIcon } from '@local/assets/icons'

import Image from '@web/components/Image'
import { convertThumbUrlToHttps } from '@web/libs/media/photoInfra'
import { ThumbnailType, THUMBNAIL_TYPES } from '@web/libs/media/photoInfra.constant'
import { ClickEvent } from '@web/types'
import Clickable from '@web/ui/components/Clickable'
import { getRandomThumbnail } from '@web/ui/pages/home/components/Sections/Section.helper'
// import PreviewPlayerCard from '@web/ui/components/PreviewPlayerCard/PreviewPlayerCard'

import { RollingImage } from './RollingImage'
import styles from './ThumbnailContent.module.scss'

export interface ThumbnailContentPropsItem {
  placeName?: string
  address?: string
  imageUrl?: string
  images?: string[]
  isClosed?: boolean
  subInfoTexts?: string[]
  href?: string
}
export interface ThumbnailContentProps {
  item: ThumbnailContentPropsItem
  onClick?: (e: ClickEvent) => void
  children?: ReactNode
  extra?: ReactNode
  isPaused?: boolean
  thumbnailType?: ThumbnailType
  clickCode?: string
  clickRank?: number
  clickPlaceId?: string
  clickBusinessId?: string
}

const NUM_IMAGE_ROLLING = 3
const ThumbnailContent = ({
  item,
  onClick,
  children,
  extra,
  isPaused = false,
  thumbnailType = THUMBNAIL_TYPES.pup.m400_800,
  clickCode,
  clickRank,
  clickPlaceId,
  clickBusinessId,
}: ThumbnailContentProps) => {
  const { placeName, address, imageUrl, images, isClosed, subInfoTexts } = item
  const rolling = images?.length === NUM_IMAGE_ROLLING

  return (
    <div className={styles.list_item_inner}>
      {/* 이미지 영역 */}
      <Clickable
        className={styles.thumb_area}
        onClick={onClick}
        href={item.href}
        nClickCode={clickCode}
        nClickRank={clickRank}
        nClickPlaceId={clickPlaceId}
        nClickBusinessId={clickBusinessId}
      >
        {/* <PreviewPlayerCard className={styles.thumb} videoItem={videoItem} height={192} /> */}
        {imageUrl ? (
          <>
            <div className="place_thumb">
              {rolling ? (
                <RollingImage thumbnailType={thumbnailType} images={images} isPaused={isPaused} />
              ) : (
                <Image
                  className={styles.thumb}
                  src={convertThumbUrlToHttps(imageUrl)}
                  width="144"
                  height="192"
                  alt=""
                  thumbnailType={thumbnailType}
                />
              )}
            </div>
            {/* {false && <PreviewPlayerCard className={styles.thumb} height={192} />} */}
          </>
        ) : (
          <>
            {/* 이미지 없는 경우 type_bg1~6 랜덤 적용 */}
            <div className="place_thumb">
              <Image
                className={styles.thumb}
                src={getRandomThumbnail()}
                width="144"
                height="192"
                alt=""
                thumbnailType={thumbnailType}
              />
            </div>
          </>
        )}
        <div className={styles.place_info_area}>
          {address && <div className={styles.address_area}>{address}</div>}
          <div className={styles.tit_area}>
            <span className={styles.name}>{placeName}</span>
            {isClosed && (
              <>
                <CommonNoticeIcon className={styles.icon} aria-hidden="true" />
                <span className="place_blind">폐업 또는 일시정지됨</span>
              </>
            )}
          </div>
          {!!subInfoTexts?.length && (
            <div className={styles.etc_area}>
              {subInfoTexts.map((text, index) => (
                <span className={styles.item} key={index}>
                  {text}
                </span>
              ))}
            </div>
          )}
        </div>
        {extra}
      </Clickable>
      {/* 정보 영역 */}
      {children}
    </div>
  )
}

export default ThumbnailContent
